import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { OrderPublicViewComponent } from "./order-public-view/order-public-view.component";
import { QRPaymentComponent } from "./qr-ayment/qr-payment.component";
import { UpsellOrderComponent } from "./upsell-order/upsell-order.component";
import { CreateUpsellOrderComponent } from "./create-upsell-order/create-upsell-order.component";
import { publicComponent } from "./layouts/public/public.component";
import { secureComponent } from "./layouts/secure/secure.component";
import { authComponent } from "./layouts/auth/auth.component";
import { ForgotpasswordComponent } from './pages/forgotpassword/forgotpassword.component';
import { ResetpasswordComponent } from './pages/resetpassword/resetpassword.component';
import { OrderPublicViewSubmitComponent } from "./order-public-view-submit/order-public-view-submit.component";
import { OrderPublicViewDeleteComponent } from "./order-public-view-delete/order-public-view-delete.component";
import { IndependentUpsellOrderComponent } from "./independent-upsell-order/independent-upsell-order.component";
import { FeedbackComponent } from './pages/feedback/feedback.component';
import { PhleboFeedbackComponent } from './pages/phlebo-feedback/phlebo-feedback.component';
import { PostOrderComponent } from "./post-order/post-order.component";
// import { FinanceReportModule } from '.pages/finance-report/finance-report.module';

const routes: Routes = [
    // otherwise redirect to Login
    {
        path: '',
        component: authComponent,
        children: [
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full',
            },
            {
                path: 'login',
                loadChildren: () =>
                    import('./pages/login/login.module').then((m) => m.LoginModule),
            },
            {
                path: 'signup',
                loadChildren: () =>
                    import('./pages/signup/signup.module').then((m) => m.SignupModule),
            },
            {
                path: 'forgot-password',
                component: ForgotpasswordComponent,
            },
            {
                path: 'reset-password/:id/:password_token',
                component: ResetpasswordComponent,
            },
            {
                path: 'policy',
                loadChildren: () =>
                    import('./pages/policy/policy.module').then((m) => m.PolicyModule),
            },
            {
                path: 'track',
                loadChildren: () =>
                    import('./pages/phlebo-track/phlebo-track.module').then((m) => m.PhleboTrackModule),
            },
            // {
            //     path: 'feedback/:id',
            //     component: FeedbackComponent,
            // },
            {
                path: 'feedback/:id',
                component: PhleboFeedbackComponent,
            }
        ],
    },
    // App routes goes here here
    {
        path: '',
        component: secureComponent,
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('./pages/dashboard/dashboard.module').then(
                        (m) => m.DashboardModule
                    ),

            },
            {
                path: 'orders',
                loadChildren: () =>
                    import('./pages/orders/orders.module').then((m) => m.OrdersModule),
            },
            // { path: 'calendar-view', component: CalendarComponent },
            {
                path: 'calendar-view',
                loadChildren: () =>
                    import('./pages/calendar/calendar.module').then((m) => m.CalendarModule),
            },
            
            {
                path: 'plans',
                loadChildren: () =>
                    import('./pages/plan/plan.module').then((m) => m.PlanModule),
            },
            {
                path: 'users',
                loadChildren: () =>
                    import('./pages/users/users.module').then((m) => m.UsersModule),
            },
            {
                path: 'customers',
                loadChildren: () =>
                    import('./pages/enduser/enduser.module').then(
                        (m) => m.EnduserModule
                    ),
            },
            {
                path: 'finance-report',
                loadChildren: () =>
                    import('./pages/finance-report/finance-report.module').then((m) => m.FinanceReportModule),
            },
            {
                path: 'payable-report',
                loadChildren: () =>
                    import('./pages/payable-report/payable-report.module').then((m) => m.PayableReportModule),
            },
            {
                path: 'receivable-report',
                loadChildren: () =>
                    import('./pages/receivable-report/receivable-report.module').then((m) => m.ReceivableReportModule),
            },
            // {
            //   path: 'roles',
            //   loadChildren: () =>
            //     import('./pages/roles/roles.module').then((m) => m.RolesModule),
            // },
            {
                path: 'phlebos',
                loadChildren: () =>
                    import('./pages/phlebos/phlebos.module').then((m) => m.PhlebosModule),
            },
            {
                path: 'reviews',
                loadChildren: () =>
                    import('./pages/reviews/reviews.module').then((m) => m.ReviewsModule),
            },
            // {
            //   path: 'task',
            //   loadChildren: () =>
            //     import('./pages/task/task.module').then(
            //       (m) => m.TaskModule
            //     ),

            // },
            // {
            //   path: 'tour',
            //   loadChildren: () =>
            //     import('./pages/tour/tour.module').then( (m) => m.TourModule
            //     ),

            // },
            {
                path: 'runner',
                loadChildren: () =>
                    import('./pages/runner/runner.module').then((m) => m.RunnerModule),
            },
            {
                path: 'sales',
                loadChildren: () =>
                    import('./pages/sales/sales.module').then(
                        (m) => m.SalesModule
                    ),
            },
            // {
            //   path: 'lablocation',
            //   loadChildren: () =>
            //     import('./pages/lablocation/lablocation.module').then(
            //       (m) => m.LablocationModule
            //     ),

            // },
            // {
            //   path: 'customerdos',
            //   loadChildren: () =>
            //     import('./pages/customerdos/customerdos.module').then(
            //       (m) => m.CustomerdosModule
            //     ),
            // },
            {
                path: 'support',
                loadChildren: () =>
                    import('./pages/support/support.module').then(
                        (m) => m.SupportModule
                    ),
            },
            {
                path: 'settings',
                loadChildren: () =>
                    import('./pages/setting/setting.module').then((m) => m.SettingModule),
            },
            {
                path: 'avslots',
                loadChildren: () =>
                    import('./pages/avslots/avslots.module').then((m) => m.AvslotsModule),
            },
            {
                path: 'patients',
                loadChildren: () =>
                    import('./pages/patients/patients.module').then((m) => m.PatientsModule),
            },

            {
                path: 'myaccount',
                loadChildren: () =>
                    import('./pages/myaccount/myaccount.module').then(
                        (m) => m.MyaccountModule
                    ),
            },
            {
                path: 'payment',
                loadChildren: () =>
                    import('./pages/paymentcheck/paymentcheck.module').then((m) => m.PaymentcheckModule),
            },
            // {
            //     path: 'prescription-uploads',
            //     loadChildren: () =>
            //         import('./pages/prescription-upload/prescription-upload.module').then((m) => m.PrescriptionUploadModule),
            // },
            {
                path: 'invoice-payment',
                loadChildren: () =>
                    import('./pages/invoice/invoice.module').then((m) => m.InvoiceModule),
            },
            {
                path: 'bankdeposit',
                loadChildren: () =>
                    import('./pages/bankdeposit/bankdeposit.module').then((m) => m.BankdepositModule),
            },
            // {
            //     path: 'reports',
            //     loadChildren: () =>
            //         import('./pages/report/report.module').then((m) => m.ReportModule),
            // },

        ],
    },
    //Public routes goes here
    {
        path: '',
        component: publicComponent,
        children: [
            {
                path: 'order-public-view/:id',
                pathMatch: 'full',
                component: OrderPublicViewComponent,
            },
            {
                path: 'order-public-view-submit/:id',
                pathMatch: 'full',
                component: OrderPublicViewSubmitComponent,
            },
            {
                path: 'order-public-view-delete/:id',
                pathMatch: 'full',
                component: OrderPublicViewDeleteComponent,
            },
            {
                path: 'qr-payment/:id',
                pathMatch: 'full',
                component: QRPaymentComponent,
            },
            {
                path: 'upsell-order/:id',
                pathMatch: 'full',
                component: UpsellOrderComponent,
            },
            {
                path: 'upsell-edit/:id/:visit_id',
                pathMatch: 'full',
                component: CreateUpsellOrderComponent,
            },
            {
                path: 'independent-upsell-order/:phleboid',
                pathMatch: 'full',
                component: IndependentUpsellOrderComponent,
            },

            {
                path: 'post-order/:secretID',
                pathMatch: 'full',
                component: PostOrderComponent,
            }
                ],
    },

];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
